import { render, staticRenderFns } from "./button-white-no-border.vue?vue&type=template&id=0a3536d2&"
import script from "./button-white-no-border.vue?vue&type=script&lang=ts&"
export * from "./button-white-no-border.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports